import { render } from "./toTopComponent.vue?vue&type=template&id=2dd29c1a&scoped=true"
import script from "./toTopComponent.vue?vue&type=script&lang=js"
export * from "./toTopComponent.vue?vue&type=script&lang=js"

import "./toTopComponent.vue?vue&type=style&index=0&id=2dd29c1a&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd29c1a"]])

export default __exports__